import React from 'react';
import { graphql, compose } from 'react-apollo';

import PackageEditor from 'Components/Presentation/ETL/PackageEditor';

import GetPackageQuery from 'GraphQueries/EtlPackages/GetQuery';
import UpdateEtlPackageMutation from 'GraphQueries/EtlPackages/UpdateMutation';

import NewEtlPackageExecutionMutation from 'GraphQueries/EtlPackageExecutions/NewMutation';
import NewEtlPackageExecutionSubscription from 'GraphQueries/EtlPackageExecutions/NewSubscription';
import UpdateEtlPackageExecutionSubscription from 'GraphQueries/EtlPackageExecutions/UpdateSubscription';

import NewEtlQueryMutation from 'GraphQueries/EtlQueries/NewMutation';
import NewEtlQuerySubscription from 'GraphQueries/EtlQueries/NewSubscription';
import UpdateEtlQueryMutation from 'GraphQueries/EtlQueries/UpdateMutation';
import UpdateBatchEtlQueryMutation from 'GraphQueries/EtlQueries/UpdateBatchMutation';
import UpdateEtlQuerySubscription from 'GraphQueries/EtlQueries/UpdateSubscription';
import DeleteEtlQueryMutation from 'GraphQueries/EtlQueries/DeleteMutation';
import DeleteEtlQuerySubscription from 'GraphQueries/EtlQueries/DeleteSubscription';

class EtlPackageEdit extends React.Component {

    static defaultProps = {
        etlPackage: { queries: [], objects: [], matrix: [1, 0, 0, 1, 0, 0], scale: 1, executions: [] },
        loading: false
    }

    componentDidMount() {
        const { subscribeToChanges } = this.props;
        subscribeToChanges();
    }

    // saveEtlPackage = async(etlPackage) => {
    //     const { onAlert, onUpdateEtlPackage } = this.props;
    //     this.setState({ saving: true });

    //     delete etlPackage.__typename;
    //     delete etlPackage.queries;
    //     delete etlPackage.executions;

    //     onUpdateEtlPackage(etlPackage).then(x => {
    //         this.setState({ saving: false });
    //         onAlert('success', `Successfully updated etl package: ${etlPackage.id}`);
    //     }).catch(error => {
    //         error.graphQLErrors.map(({ message }, i) => {
    //             if (message.match(/not authorized/gi)) {
    //                 onAlert('error', 'You are not authorised to update an etl package, please see a System Admin');
    //             }
    //             else { onAlert('error', message); }
    //         });
    //         this.setState({ saving: true });
    //     })
    // }

    saveEtlPackageExecution = async(etlPackageExecution) => {
        const { onAlert, onAddEtlPackageExecution } = this.props;
        this.setState({ saving: true });
        onAddEtlPackageExecution(etlPackageExecution).then(x => {
            this.setState({ saving: false });
            onAlert('success', `Successfully created etl package execution: ${etlPackageExecution.id}`);
        }).catch(error => {
            error.graphQLErrors.map(({ message }, i) => {
                if (message.match(/not authorized/gi)) {
                    onAlert('error', 'You are not authorised to create etl package executions, please see a System Admin');
                }
                else { onAlert('error', message); }
            });
            this.setState({ saving: true });
        })
    }

    saveEtlQuery = async(query) => {
        const { onAlert, onAddEtlQuery } = this.props;
        this.setState({ saving: true });
        onAddEtlQuery(query).then(x => {
            this.setState({ saving: false });
            onAlert('success', `Successfully created query: ${query.id}`);
        }).catch(error => {
            error.graphQLErrors.map(({ message }, i) => {
                if (message.match(/not authorized/gi)) {
                    onAlert('error', 'You are not authorised to create queries, please see a System Admin');
                }
                else { onAlert('error', message); }
            });
            this.setState({ saving: true });
        })
    }

    saveBatchEtlQueries = async(queries) => {
        const { onAlert, onBatchAdd } = this.props;
        this.setState({ saving: true });

        onBatchAdd(queries).then(x => {
            this.setState({ saving: false });
            onAlert('success', `Successfully updated etl package`);
        });
    }

    editEtlQuery = async(query) => {
        const { onAlert, onUpdateEtlQuery } = this.props;
        this.setState({ saving: true });

        delete query.__typename;

        onUpdateEtlQuery(query).then(x => {
            this.setState({ saving: false });
            onAlert('success', `Successfully updated query: ${query.id}`);
        }).catch(error => {
            error.graphQLErrors.map(({ message }, i) => {
                if (message.match(/not authorized/gi)) {
                    onAlert('error', 'You are not authorised to update queries, please see a System Admin');
                }
                else { onAlert('error', message); }
            });
            this.setState({ saving: true });
        })
    }

    deleteEtlQuery = async(query) => {
        const { onAlert, onDeleteEtlQuery } = this.props;
        this.setState({ saving: true });
        onDeleteEtlQuery(query.id).then(x => {
            this.setState({ saving: false });
            onAlert('success', `Successfully deleted query: ${query.id}`);
        }).catch(error => {
            error.graphQLErrors.map(({ message }, i) => {
                if (message.match(/not authorized/gi)) {
                    onAlert('error', 'You are not authorised to delete queries, please see a System Admin');
                }
                else { onAlert('error', message); }
            });
            this.setState({ saving: true });
        })
    };

    render() {
        const { etlPackage } = this.props;
        return (
            <PackageEditor etlPackage={etlPackage} onPackageExecuted={this.saveEtlPackageExecution} onSaveEtlQuery={this.saveEtlQuery} 
                onSaveBatchEtlQueries={this.saveBatchEtlQueries} onEditEtlQuery={this.editEtlQuery} onDeleteEtlQuery={this.deleteEtlQuery} />
        );
    }
}

export default compose(
    graphql(GetPackageQuery, {
        options: ({ match: { params: { id, version } } }) => ({ variables: { id, version } }),
        props: ({ data: { getEtlPackage, loading, subscribeToMore } }) => ({ 
            etlPackage: getEtlPackage, 
            loading,
            subscribeToChanges: params => {
                subscribeToMore({
                    document: NewEtlPackageExecutionSubscription,
                    updateQuery: (prev, { subscriptionData: { data: { onCreateEtlPackageExecution } } }) => 
                    {
                        return {
                            ...prev,
                            getEtlPackage: { 
                                ...prev.getEtlPackage, 
                                executions: [onCreateEtlPackageExecution, ...prev.getEtlPackage.executions.filter(item => item.id !== onCreateEtlPackageExecution.id)] 
                            }
                        };
                    }
                });
                subscribeToMore({
                    document: UpdateEtlPackageExecutionSubscription,                    
                    updateQuery: (prev, { subscriptionData: { data: { onUpdateEtlPackageExecution } } }) => 
                    {
                        return { 
                            ...prev, 
                            getEtlPackage: { 
                                ...prev.getEtlPackage, 
                                executions: [onUpdateEtlPackageExecution, ...prev.getEtlPackage.executions.filter(item => item.id !== onUpdateEtlPackageExecution.id)] 
                            }
                        };
                    }
                });
                subscribeToMore({
                    document: NewEtlQuerySubscription,
                    updateQuery: (prev, { subscriptionData: { data: { onCreateEtlQuery } } }) => 
                    {
                        return { 
                            ...prev, 
                            getEtlPackage: { 
                                ...prev.getEtlPackage, 
                                queries: [onCreateEtlQuery, ...prev.getEtlPackage.queries.filter(item => item.id !== onCreateEtlQuery.id)] 
                            }
                        };
                    }
                });
                subscribeToMore({
                    document: UpdateEtlQuerySubscription,
                    updateQuery: (prev, { subscriptionData: { data: { onUpdateEtlQuery } } }) => 
                    {
                        return { 
                            ...prev, 
                            getEtlPackage: { 
                                ...prev.getEtlPackage, 
                                queries: [onUpdateEtlQuery, ...prev.getEtlPackage.queries.filter(item => item.id !== onUpdateEtlQuery.id)] 
                            }
                        };
                    }
                });
                subscribeToMore({
                    document: DeleteEtlQuerySubscription,
                    updateQuery: (prev, { subscriptionData: { data: { onDeleteEtlQuery } } }) => 
                    {
                        return { 
                            ...prev, 
                            getEtlPackage: { 
                                ...prev.getEtlPackage, 
                                queries: [...prev.getEtlPackage.queries.filter(item => item.id !== onDeleteEtlQuery.id)] 
                            }
                        };
                    }
                });
            }
        })
    }),
    //graphql(UpdateEtlPackageMutation(), { props: ({ mutate }) => ({ onUpdateEtlPackage: input => mutate({ variables: { input } }) }) }),
    graphql(NewEtlPackageExecutionMutation(['etlPackageId', 'order', 'status', 'statusMessage', 'steps { queryId, status, statusMessage }']), { 
        props: ({ mutate }) => ({ onAddEtlPackageExecution: input => mutate({ variables: { input } }) }) 
    }), 
    graphql(NewEtlQueryMutation(), { props: ({ mutate }) => ({ onAddEtlQuery: input => mutate({ variables: { input } }) }) }),
    graphql(UpdateEtlQueryMutation(), { 
        props: ({ mutate }) => ({ onUpdateEtlQuery: input => mutate({ variables: { input: {...input, 
            settings: { name: input.settings.name, tableId: input.settings.tableId, compressed: input.settings.compressed, manifest: input.settings.manifest, escapeDelimiter: input.settings.escapeDelimiter, csvFile: input.settings.csvFile, delimiter: input.settings.delimiter, ignoreHeaderRows: input.settings.ignoreHeaderRows, copyOnly: input.settings.copyOnly, copyFormatRegex: input.settings.copyFormatRegex },
            columns: [...input.columns.map(x => ({ id: x.id, order: x.order, name: x.name, type: x.type, dataType: x.dataType, defaultValue: x.defaultValue, isIdentity: x.isIdentity, alias: x.alias, maxLength: x.maxLength, scale: x.scale, defaultValueIsFunction: x.defaultValueIsFunction }))] } } }) }) 
    }),
    graphql(UpdateBatchEtlQueryMutation, {
        props: ({ mutate }) => ({ onBatchAdd: etlQueries => mutate({ variables: { etlQueries: [...etlQueries.map(x => ({ id: x.id, etlPackageId: x.etlPackageId, icon: x.icon, parent_ids: x.parent_ids, step: x.step, x: x.x, y: x.y, 
            settings: { name: x.settings.name, tableId: x.settings.tableId, compressed: x.settings.compressed, manifest: x.settings.manifest, escapeDelimiter: x.settings.escapeDelimiter, csvFile: x.settings.csvFile, delimiter: x.settings.delimiter, ignoreHeaderRows: x.settings.ignoreHeaderRows, copyOnly: x.settings.copyOnly, copyFormatRegex: x.settings.copyFormatRegex },
            columns: [...x.columns.map(m => ({ id: m.id, order: m.order, name: m.name, type: m.type, dataType: m.dataType, defaultValue: m.defaultValue, isIdentity: m.isIdentity, alias: m.alias, maxLength: m.maxLength, scale: m.scale, defaultValueIsFunction: m.defaultValueIsFunction }))] 
        }))] } }) })
    }),
    graphql(DeleteEtlQueryMutation(), { props: ({ mutate }) => ({ onDeleteEtlQuery: id => mutate({ variables: { id } }) }) })
)(EtlPackageEdit);




// WEBPACK FOOTER //
// ./src/Components/Containers/EtlPackages/Edit.js